export default __webpack_public_path__ + "static/media/r3.d241fda3.jpg";